import IconLocation from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import IconPhone from "@mui/icons-material/Phone";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { translate } from "../../app/utils";

const Contacts = () => {
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error for the field being typed in
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = () => {
    let newErrors = {};
    if (!formValues.name?.trim())
      newErrors.name = [translate("required") || "Name is required"];
    if (!formValues.subject?.trim())
      newErrors.subject = [translate("required") || "Subject is required"];

    if (!formValues.email?.trim()) {
      newErrors.email = [translate("required") || "Email is required"];
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
      newErrors.email = ["Invalid email format"];
    }

    if (!formValues.message?.trim())
      newErrors.message = [translate("required") || "Message is required"];

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Proceed with submit action
      console.log("Form submitted successfully", formValues);
      setFormValues({});
    }
  };

  return (
    <Box sx={{ px: { xs: 2, md: 6 }, py: 6 }}>
      <Grid container spacing={4}>
        {/* LEFT SIDE */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <Paper sx={{ p: 3, display: "flex", gap: 2 }}>
                <IconLocation fontSize="large" />
                <Box>
                  <Typography fontWeight="bold">
                    {translate("ourOffice")}
                  </Typography>
                  <Typography variant="body2">
                    Bank of Tanzania Head Office, 16 Jakaya Kikwete Road 1st
                    Floor, P.O Box 2303 40184 Dodoma Tanzania.
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={12}>
              <Paper sx={{ p: 3, display: "flex", gap: 2 }}>
                <IconPhone fontSize="large" />
                <Box>
                  <Typography fontWeight="bold">
                    {translate("phone")}
                  </Typography>
                  <Typography variant="body2">
                    <a href="tel:+255262963182-7">+255(0) 262963182-7</a>
                  </Typography>
                  <Typography variant="body2">
                    <a href="tel:+255262232541">+255(0) 262232541</a>
                  </Typography>
                </Box>
              </Paper>
            </Grid>

            <Grid size={12}>
              <Paper sx={{ p: 3, display: "flex", gap: 2 }}>
                <MailIcon fontSize="large" />
                <Box>
                  <Typography fontWeight="bold">
                    {translate("emailUs")}
                  </Typography>
                  <Typography variant="body2">
                    <a href="mailto:info@bot.go.tz">info@bot.go.tz</a>
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        {/* RIGHT SIDE FORM */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            {translate("writeToUs")}
          </Typography>

          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                margin="dense"
                label={translate("name")}
                name="name"
                value={formValues.name || ""}
                onChange={handleChange}
                error={Boolean(errors.name)}
                helperText={errors.name?.[0] || ""}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                fullWidth
                margin="dense"
                label={translate("subject")}
                name="subject"
                value={formValues.subject || ""}
                onChange={handleChange}
                error={Boolean(errors.subject)}
                helperText={errors.subject?.[0] || ""}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                fullWidth
                margin="dense"
                label={translate("email")}
                name="email"
                value={formValues.email || ""}
                onChange={handleChange}
                error={Boolean(errors.email)}
                helperText={errors.email?.[0] || ""}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                fullWidth
                margin="dense"
                label={translate("message")}
                name="message"
                multiline
                minRows={5}
                value={formValues.message || ""}
                onChange={handleChange}
                error={Boolean(errors.message)}
                helperText={errors.message?.[0] || ""}
              />
            </Grid>

            <Grid
              size={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button variant="contained" onClick={handleSubmit}>
                {translate("submit")}
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {/* MAP */}
        <Grid size={12}>
          <Box
            sx={{
              mt: 4,
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: 3,
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.5783572356545!2d35.75255527974385!3d-6.187138244612547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x184de54b7c010887%3A0x35e5b125b0f721ec!2sBank%20Of%20Tanzania!5e0!3m2!1sen!2stz!4v1734935900370!5m2!1sen!2stz"
              width="100%"
              height="450"
              loading="lazy"
              title="Bank of Tanzania Library"
              style={{ border: "none" }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Contacts;
